export const plural = (word:string,val:number, plural = word + 's') => {
  return val > 1 ? plural : word
};